export default __webpack_public_path__ + "static/media/Upadhyaya.df631b08.png";